unit AgentRegisterClient;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  SMX.Web.Document.Utils,
  RegisterForm,
  XData.Web.Connection,
  XData.Web.Client,
  WEBLib.StdCtrls,
  WEBLib.Country,
  Vcl.Controls,
  WEBLib.WebCtrls,
  Vcl.StdCtrls,
  WEBLib.ExtCtrls,
  GA.Registration.Classes,
  GA.Return.Types;

type
  TAgentClientForm = class(TRegisterWebForm)
    CancelButton: TButton;
    procedure CancelButtonClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    FAgentId: Integer;
    function IsTenantLimitError(const AMessage: string): Boolean;
    procedure HideInheritedAgentControls;
    { Private declarations }
  protected
    function LoadUser: TRegisterUser; override;
    function LoadOrganisation: TRegisterOrganisation; override;
    [async]
    procedure LoadThankYou; async; override;
    procedure HandleRegistrationError(E: Exception); override;
  public
    { Public declarations }
    property AgentId: Integer read FAgentId write FAgentId;
  protected procedure LoadDFMValues; override; end;

var
  AgentClientForm: TAgentClientForm;

implementation

{$R *.dfm}

procedure TAgentClientForm.CancelButtonClick(Sender: TObject);
begin
  ModalResult := mrCancel;
end;

procedure TAgentClientForm.HideInheritedAgentControls;
begin
  OrganisationTypeCombo.Visible := False;
  AgentSubmissionTypeCombo.Visible := False;
  AgentOrganisationRef.Visible := False;
  TDocUtils.hideElement('OrganisationType');
  TDocUtils.hideElement('AgentSubmissionType');
  TDocUtils.hideElement('AgentOrganisationRef');
  TDocUtils.hideElement('agentOrganisationRefDiv');
end;

procedure TAgentClientForm.WebFormCreate(Sender: TObject);
begin
  inherited;
  HideInheritedAgentControls;
end;

procedure TAgentClientForm.WebFormShow(Sender: TObject);
begin
  inherited;
  HideInheritedAgentControls;
end;

{ TAgentClientForm }

function TAgentClientForm.IsTenantLimitError(const AMessage: string): Boolean;
var
  lLowerMessage: string;
begin
  if Pos(GATenantLimitExceededMessage, AMessage) > 0 then
    Exit(True);

  lLowerMessage := LowerCase(AMessage);
  Result := Pos('maximum number of client organisations', lLowerMessage) > 0;
end;

procedure TAgentClientForm.HandleRegistrationError(E: Exception);
begin
  if IsTenantLimitError(E.Message) then
    MessageDlg(GATenantLimitUserMessage, TMsgDlgType.mtWarning, [TMsgDlgBtn.mbOK])
  else
    inherited;
end;

function TAgentClientForm.LoadOrganisation: TRegisterOrganisation;
begin
  Result := inherited LoadOrganisation;
  Result.AgentId := FAgentId;
  Result.OrganisationKind := 'Standard';
  Result.AgentSubmissionType := '';
  Result.AgentOrganisationRef := '';
end;

procedure TAgentClientForm.LoadThankYou;
begin
  //inherited;
  ModalResult := mrOK;
end;

function TAgentClientForm.LoadUser: TRegisterUser;
begin
  Result := inherited LoadUser;
  Result.InternalId := 0;
end;

procedure TAgentClientForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  CancelButton := TButton.Create('CancelButton');

  CancelButton.BeforeLoadDFMValues;
  OrganisationTypeCombo.BeforeLoadDFMValues;
  AgentSubmissionTypeCombo.BeforeLoadDFMValues;
  AgentOrganisationRef.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 392;
    CancelButton.Top := 255;
    CancelButton.Width := 96;
    CancelButton.Height := 25;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 12;
    CancelButton.ElementClassName := 'btn btn-light';
    CancelButton.ElementFont := efCSS;
    CancelButton.ElementPosition := epIgnore;
    CancelButton.HeightStyle := ssAuto;
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.WidthStyle := ssAuto;
    CancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelButton, Self, 'OnClick', 'CancelButtonClick');
    OrganisationTypeCombo.Visible := False;
    AgentSubmissionTypeCombo.Visible := False;
    AgentOrganisationRef.Visible := False;
  finally
    CancelButton.AfterLoadDFMValues;
    OrganisationTypeCombo.AfterLoadDFMValues;
    AgentSubmissionTypeCombo.AfterLoadDFMValues;
    AgentOrganisationRef.AfterLoadDFMValues;
  end;
end;

end.
